import {
    SYSTEM_SETTING,
} from '@/store/api/home';

const state = {
};

const getters = {
};

const actions = {
    requestLayoutData({ rootState }) {
        return rootState.app.$http.get(SYSTEM_SETTING, { loading: true });
    }
};

const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

